import { Type } from '@sinclair/typebox';
import { ConditionValueSchema } from "./condition.mjs";
export const FamilyAttributeResponseSchema = Type.Object({
    familyId: Type.Number(),
    attributeId: Type.Number(),
    attributeName: Type.String(),
    required: Type.Boolean(),
    // Type.Null must be placed first in Type.Union, otherwise, incoming null values will be converted to 0
    value: Type.Union([Type.Null(), ConditionValueSchema]),
    versionId: Type.Number(),
});
export const CreateFamilyAttributeSchema = Type.Omit(FamilyAttributeResponseSchema, ['attributeName']);
export const UpdateFamilyAttributeSchema = Type.Partial(Type.Omit(CreateFamilyAttributeSchema, ['familyId', 'attributeId', 'versionId']));
//# sourceMappingURL=family-attributes.js.map